import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { CardBoxProps as Props } from './types';

export const CardBox = memo(
  ({
    id,
    className,
    headerSx,
    hideHeader,
    title,
    titleProps,
    subTitle,
    subTitleProps,
    contentSx,
    contentGradient,
    sx,
    children,
    shadow,
    actions,
    transparent,
    headerDivider,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('CardBox', className, { 'no-shadow': !shadow })}
        id={id}
        sx={{
          background: transparent ? 'transparent' : undefined,
          ...sx,
        }}
        headerDivider={headerDivider}
      >
        {!hideHeader && (title || subTitle) && (
          <Styled.Header className="CardBoxHeader" sx={headerSx}>
            {title && (
              <Styled.Title {...titleProps}>
                {title}

                {actions}
              </Styled.Title>
            )}
            {subTitle && typeof subTitle === 'string' && (
              <Styled.SubTitle
                className="SubTitle"
                variant="body1"
                {...subTitleProps}
              >
                {subTitle}
              </Styled.SubTitle>
            )}
            {subTitle && typeof subTitle !== 'string' && subTitle}
          </Styled.Header>
        )}

        <Styled.Content
          className={classnames('CardBoxContent', {
            gradient: contentGradient,
          })}
          sx={{ p: transparent ? 0 : undefined, ...contentSx }}
        >
          {children}
        </Styled.Content>
      </Styled.Wrapper>
    );
  }
);

CardBox.displayName = 'CardBox';
